import React, {Component} from 'react';
import {connect} from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import ActionTypes from "../../misc/actionTypes";
import Analytics from './../../analytics';
import UserLoginButton from './../ui/userLoginButton';
import {toggleUserPopup, changeMessageBoxState} from "../../actions/actionFunctions";
import {SaveIcon} from "./icons";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {saveQuote} from "../../api/server-api";
import {UserPopupTypes} from "../visComponents/constants";
import {showQuoteSavedNotification} from "../ui/successNotification";

export class SaveButton extends Component {

  saving = false;

  handleSaveQuote = () => {
    if (!UserLoginButton.handleLoginClick({
      ...this.props,
      saveQuoteAfterLogin: true,
      userPopupType: UserPopupTypes.NewDesign
    })) {
      Analytics.sendClickEvent("save-button-show-login");
    } else if (!this.saving) {
      Analytics.sendClickEvent("save-button");
      this.saveQuoteSubmit();
    }
    // const fabricatorSettings = this.props.fabricatorData.settings;
    // if ((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !this.props.isPhoneNumberValidated) {
    //   Analytics.sendClickEvent("save-button-show-login");
    //   this.props.toggleUserPopup({
    //     userPopupOpened: true,
    //     saveQuoteAfterLogin: true
    //   });
    // } else {
    //   Analytics.sendClickEvent("save-button");
    //   this.saveQuoteSubmit();
    // }
  };

  saveQuoteSubmit = () => {
    $(window).trigger(ActionTypes.REMOVE_GREEN_ZONE_ON_CANVAS, () => {
      if (!this.saving) {
        this.saving = true;
        loaderEnable("loader.savingQuoteText");
        saveQuote(true)
          .then((response) => {
            if (response) {
              let responseDataBase = response;
              if (response.data) {
                responseDataBase = response.data;
              }
              const responseData = typeof responseDataBase === 'object' ? responseDataBase : JSON.parse(responseDataBase);
              console.log('saveButton saveQuote response:', responseData);
              loaderDisable();
            }
            showQuoteSavedNotification();
            this.saving = false;
            // downloadCanvasImageById(this.props.canvasId);
          })
          .catch((error) => {
            console.log('saveButton saveQuote error:', error);
            loaderDisable();
            this.saving = false;
          })
      }
    });
  };

  render() {
    return (
      <button className="mobilebutton mobilebutton--save"
              onClick={() => this.handleSaveQuote()}>
        <SaveIcon/>
        <span className="mobilebutton-text"><FormattedMessage id="saveButton"/></span>
      </button>
    )
  }

}
const mapStateToProps = (store) => ({
  userIsLoggedIn: store.userState.userIsLoggedIn,
  isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  fabricatorData: store.fabricatorState
});
export default connect(mapStateToProps, {
  toggleUserPopup,
  changeMessageBoxState
})(SaveButton);
